import { render, staticRenderFns } from "./OrganizationSummary.vue?vue&type=template&id=2248f982&scoped=true"
import script from "./OrganizationSummary.vue?vue&type=script&lang=js"
export * from "./OrganizationSummary.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSummary.vue?vue&type=style&index=0&id=2248f982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248f982",
  null
  
)

export default component.exports